import { useTranslation } from 'react-i18next'

import { Button } from './ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from './ui/dialog'

export const ConfirmButton = ({
  open,
  onOpenChange,
  children,
  title,
  description,
  onConfirm,
  confirmLabel,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  children: React.ReactNode
  title: string
  description: string
  onConfirm: () => void
  /** Text of the confirm button, "Smazat" by default. */
  confirmLabel?: string
}) => {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{description}</DialogDescription>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">{t('generic.button.cancel')}</Button>
          </DialogClose>
          <Button onClick={onConfirm}>{confirmLabel ?? t('generic.button.delete')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
